<div class="header">
  <h2>Spare parts details</h2>
  <div class="header-buttons">
    <button mat-raised-button color="accent" (click)="back()">
      <mat-icon>arrow_back</mat-icon>
      Back
    </button>
  </div>
</div>

<loading-bar *ngIf="loading" />

<p *ngIf="!loading && !sparePart">
  <strong>Spare part not found!</strong>
</p>

<div class="two-columns-layout" *ngIf="!loading && sparePart">
  <div class="column-one">
    <p><strong>Spare part ID:</strong> {{ sparePart.id }}</p>
    <p><strong>Part Number:</strong> {{ sparePart.partNumber }}</p>
    <p><strong>Assembly:</strong> {{ sparePart.assembly }}</p>
    <p><strong>Source:</strong> {{ sparePart.source }}</p>
    <p><strong>Modified By:</strong> {{ sparePart.modifiedBy }}</p>
    <p><strong>Remark:</strong> {{ sparePart.remark }}</p>
    <p><strong>Created By:</strong> {{ sparePart.createdBy }}</p>
    <p><strong>Created Date:</strong> {{ sparePart.createdDate }}</p>
    <p><strong>Data Source:</strong> {{ sparePart.dataSource }}</p>
    <p><strong>Comp Unit:</strong> {{ sparePart.compUnit }}</p>
    <p><strong>Description:</strong> {{ sparePart.description }}</p>
  </div>
  <div class="column-two">
    <p><strong>Type Designation:</strong> {{ sparePart.typeDesignation }}</p>
    <p><strong>Spare Part Description:</strong> {{ sparePart.sparePartDescription }}</p>
    <p><strong>Functional Description:</strong> {{ sparePart.functionalDescription }}</p>
    <p><strong>Tech Data:</strong> {{ sparePart.techData }}</p>
    <p><strong>Spare Part Drives Type Code:</strong> {{ sparePart.sparePartDrivesTypeCode }}</p>
    <p><strong>Spare Parts Type Code:</strong> {{ sparePart.sparePartsTypeCode }}</p>
    <p><strong>Estimated Pm Hours:</strong> {{ sparePart.estimatedPmHours }}</p>
    <p><strong>External Additional Info:</strong> {{ sparePart.externalAdditionalInfo }}</p>
    <p><strong>Module:</strong> {{ sparePart.module }}</p>
    <p><strong>Is Active:</strong> {{ sparePart.isActive }}</p>
    <p><strong>Component:</strong> {{ sparePart.component }}</p>
  </div>
</div>